import { GameId } from '@common'
import { StoreMission } from '@common/models/bonus'
import { StaticImageData } from 'next/image'
import { useTranslations } from 'next-intl'

import BrawlPass from '@/assets/images/storefronts/brawlstars/mission-brawl-pass.png'
import DailyLogins from '@/assets/images/storefronts/brawlstars/mission-daily-logins.png'
import WinBattles from '@/assets/images/storefronts/brawlstars/mission-win-battles.png'
import CompleteHomeVillage from '@/assets/images/storefronts/clashofclans/challenge-complete-home-village.png'
import DestroyTownhalls from '@/assets/images/storefronts/clashofclans/challenge-destroy-townhalls.png'
import LogIn from '@/assets/images/storefronts/clashofclans/challenge-log-in.png'

type Missions = {
  [key: string]: {
    image: StaticImageData
    title: string
    type: 'normal' | 'binary'
  }
}

export const useGetSupportedMissions = ({
  gameId,
  mission,
}: {
  gameId: GameId
  mission: StoreMission
}): Missions | null => {
  const t = useTranslations()
  const { target } = mission

  if (!mission) {
    return null
  }

  switch (gameId) {
    case 'brawlstars':
      return {
        daily_logins: {
          image: DailyLogins,
          title: t('laser_mission_title_daily_logins', { target }),
          type: 'normal',
        },
        complete_brawl_pass: {
          image: BrawlPass,
          title: t('laser_mission_complete_brawl_pass'),
          type: 'binary',
        },
        win_matches: {
          image: WinBattles,
          title: t('laser_mission_win_matches', { target }),
          type: 'normal',
        },
      }
    case 'clashroyale':
      return {
        daily_logins: {
          image: DailyLogins,
          title: t('laser_mission_title_daily_logins', { target }),
          type: 'normal',
        },
        complete_brawl_pass: {
          image: BrawlPass,
          title: t('laser_mission_complete_brawl_pass'),
          type: 'binary',
        },
        win_matches: {
          image: WinBattles,
          title: t('laser_mission_win_matches', { target }),
          type: 'normal',
        },
      }
    case 'clashofclans':
      return {
        daily_logins: {
          image: LogIn,
          title: t('magic_mission_title_daily_logins', { target: mission.target }),
          type: 'normal',
        },
        destroy_townhalls: {
          image: DestroyTownhalls,
          title: t('magic_mission_title_destroy_townhalls', { target: mission.target }),
          type: 'normal',
        },
        star_bonus_delivered: {
          image: CompleteHomeVillage,
          title: t('magic_mission_title_star_bonus_delivered'),
          type: 'binary',
        },
      }
    default:
      return null
  }
}
